var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SpFinder',{ref:"finder",attrs:{"row-key":"item_id","split-count":10,"url":_vm.table_url,"setting":_vm.setting,"fixed-row-action":"","reserve-selection":"","row-actions-fixed-align":"left"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }